export default { DOWNLOADED: 'Proposal Downloaded' };
